if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();

        // Load as early as possible so the section (e.g. the cart "Forgot something?" row, which
        // sits at the top of the page) doesn't lag behind the rest of the content. Previously this
        // waited for requestIdleCallback, which deferred the fetch until the browser went idle and
        // made the section pop in noticeably late.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        const queryUrl = this.getQueryUrl();
        if (!queryUrl) {
          this.removeSection();
          return;
        }

        // localStorage is read synchronously, so we already know items exist before the network
        // fetch resolves. Reveal the section and drop in a skeleton row that reserves ~one product
        // row of height NOW. That way, when the real cards arrive a moment later they swap into the
        // already-reserved space instead of shoving the cart (which sits below this) down = no jump.
        this.renderSkeleton();

        fetch(queryUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) {
              this.removeSection();
              return;
            }

            const recommendations = sectionInnerHTML.querySelector('recently-viewed-products');
            if (recommendations && recommendations.innerHTML.trim().length) {
              const section = recommendations.querySelector('.section');
              if (section) section.classList.remove('hidden');

              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations && recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              this.removeSection();
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
            this.removeSection();
          });
      }

      renderSkeleton() {
        const section = this.querySelector('.section');
        if (section) section.classList.remove('hidden');
        const wrap = this.querySelector('.products-grid-wrap');
        if (!wrap) return;
        const card =
          '<div class="rv-skel-card" aria-hidden="true">' +
          '<div class="rv-skel-img"></div>' +
          '<div class="rv-skel-line"></div>' +
          '<div class="rv-skel-line rv-skel-line--sm"></div>' +
          '<div class="rv-skel-btn"></div>' +
          '</div>';
        wrap.innerHTML = '<div class="rv-skel-row" role="presentation">' + card.repeat(6) + '</div>';
      }

      getQueryUrl() {
        const items = JSON.parse(window.localStorage.getItem('hypertheme:recently-viewed') || '[]');
        const productId = parseInt(this.dataset.productId);
        const productsToShow = parseInt(this.dataset.productsToShow);

        if (items.includes(productId)) {
          items.splice(items.indexOf(productId), 1);
        }

        if (items.length > 0) {
          const queryParams = items
            .map((item) => 'id:' + item)
            .slice(0, productsToShow)
            .join(' OR ');

          return this.dataset.url + queryParams;
        }

        return false;
      }

      removeSection() {
        this.remove();
      }

      sendTrekkieEvent(numberProducts) {
        if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.lib || !window.ShopifyAnalytics.lib.track) {
          return;
        }
        let didPageJumpOccur = this.getBoundingClientRect().top <= window.innerHeight;

        window.ShopifyAnalytics.lib.track('Recently Viewed Products Displayed', {
          theme: Shopify.theme.name,
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberProducts,
        });
      }
    }
  );
}
